"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgDroplets01 = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("path", { d: "M5 1a1 1 0 0 0-.85.473 26.744 26.744 0 0 0-.485.818 41.69 41.69 0 0 0-1.057 1.948 23.96 23.96 0 0 0-1.077 2.41C1.241 7.428 1 8.274 1 9a4 4 0 0 0 8 0c0-.725-.242-1.571-.531-2.352A23.96 23.96 0 0 0 7.392 4.24 41.68 41.68 0 0 0 5.85 1.473 1 1 0 0 0 5 1ZM9 16a7 7 0 1 0 14 0c0-1.265-.429-2.818-1-4.355-.58-1.564-1.349-3.216-2.108-4.715a82.41 82.41 0 0 0-2.971-5.341l-.07-.116a1 1 0 0 0-1.701 0l-.07.116-.195.32a82.41 82.41 0 0 0-2.777 5.02c-.76 1.5-1.527 3.152-2.108 4.716-.571 1.537-1 3.09-1 4.355Z", fill: "currentColor" }) }))); };
exports.default = SvgDroplets01;
